// src/components/IngredientTile.jsx — ohapotato v2026.10.36
import React, { memo, useRef, useState } from 'react';

const IngredientTile = memo(function IngredientTile({ ingredient, isSelected, onToggle, inPantry }) {
  const ref = useRef(null);
  const [hovered, setHovered] = useState(false);

  const handleToggle = () => {
    if (ref.current) {
      ref.current.classList.remove('tile-pop');
      void ref.current.offsetWidth;
      ref.current.classList.add('tile-pop');
    }
    onToggle(ingredient.id);
  };

  const getBg = () => {
    if (isSelected) return 'var(--accent-green-bg)';
    if (hovered)    return 'var(--bg-pill)';
    return 'var(--bg-card)';
  };

  const getBorder = () => {
    if (isSelected) return '1.5px solid var(--accent-green)';
    if (hovered)    return '1.5px solid var(--border-strong)';
    return '1.5px solid var(--border-base)';
  };

  return (
    <div
      ref={ref}
      onClick={handleToggle}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      role="checkbox"
      aria-checked={isSelected}
      tabIndex={0}
      onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && handleToggle()}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '4px',
        padding: '9px 4px',
        borderRadius: 'var(--radius-md)',
        border: getBorder(),
        background: getBg(),
        cursor: 'pointer',
        transform: hovered && !isSelected ? 'translateY(-1px)' : 'none',
        boxShadow: isSelected
          ? '0 0 0 3px rgba(46,125,69,0.12)'
          : hovered
            ? 'var(--shadow-sm)'
            : 'none',
        userSelect: 'none',
        position: 'relative',
        outline: 'none',
        minHeight: '68px',
        transition: 'border-color 0.12s ease, background 0.12s ease, transform 0.12s ease, box-shadow 0.12s ease',
      }}
    >
      {isSelected && (
        <span style={{
          position: 'absolute', top: '4px', right: '4px',
          width: '13px', height: '13px', borderRadius: '50%',
          background: 'var(--accent-green)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: '7px', fontWeight: '700', color: '#fff', lineHeight: 1,
        }}>✓</span>
      )}
      {!isSelected && inPantry && (
        <span style={{
          position: 'absolute', top: '4px', right: '4px',
          fontSize: '8px', lineHeight: 1, opacity: 0.85,
        }}>🥔</span>
      )}
      <span style={{
        fontSize: '22px', lineHeight: '1',
        transform: hovered ? 'scale(1.10)' : 'scale(1)',
        transition: 'transform 0.12s ease',
      }}>{ingredient.emoji}</span>
      <span style={{
        fontSize: '12px',
        fontWeight: '500',
        fontFamily: 'var(--font-body)',
        color: isSelected ? 'var(--accent-green)' : hovered ? 'var(--text-secondary)' : 'var(--text-muted)',
        textAlign: 'center',
        lineHeight: '1.2',
        transition: 'color 0.12s ease',
      }}>{ingredient.label}</span>
    </div>
  );
});

export default IngredientTile;
